module.exports = __webpack_public_path__ + "static/img/user.30c9f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tabbar/user.png
// module id = d+cF
// module chunks = 2